export const endpointName = 'Document';
export const createDocumentEndpoint = 'Document';
export const createDocumentChapterEndpoint = 'DocumentChapter';
export const getDocumentChapterEndpoint = 'DocumentChapter';
export const updateDocumentChapterEndpoint = 'DocumentChapter/Update';
export const getDocumentEndpoint = 'Document';
export const updateDocumentEndpoint = 'Document/Update';
export const deleteDocumentEndpoint = 'Document/Delete';
